import React from "react";

const DeleteAlert = (props) => {
  const shortenTitle = (Title) => {
    if (Title.length < 39) {
      return Title;
    } else {
      return (
        <React.Fragment>
          {Title.slice(0, 35) + " ..."}
          <p className="title-popup">{Title}</p>
        </React.Fragment>
      );
    }
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  return (
    <div className="modal-overlay">
      <div className="outline" onClick={() => props.Close()}></div>
      <div className="modal-body delete-modal">
        <div className="modal-head">
          <span className="info">
            <p className="jpa-name">
              {shortenTitle(props.Data.position.title)}
            </p>
            <p className="jpa-location">{props.Data.position.country}</p>
          </span>
          <i className="feather-x" onClick={() => props.Close()}></i>
        </div>
        <h1 className="modal-message">
          {translateText("confirm_remove_permenantly")}
        </h1>
        <div className="actions">
          <button className="secondary-btn" onClick={() => props.Cancel()}>
            {translateText("cancel")}
          </button>
          <button className="primary-btn" onClick={() => props.Accept()}>
            {translateText("delete")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAlert;
